// src/components/loader/Loader.jsx
import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import Lottie from 'lottie-react';
import loaderAnimation from '../../assets/loader/Loader1.json';

const Loader = ({
    fullScreen = true,
    message = "Loading...",
    showMessage = true,
    size = 200, // Default size for the loader
    containerBg = "rgba(255, 255, 255, 0.1)",
    backdropBlur = "10px",
    messageColor = "navy.700"
}) => {
    if (fullScreen) {
        return (
            <Flex
                position="fixed"
                top="0"
                left="0"
                right="0"
                bottom="0"
                minH="100vh"
                h="100vh"
                w="100%"
                alignItems="center"
                justifyContent="center"
                bg={containerBg}
                backdropFilter={backdropBlur}
                zIndex={9999}
            >
                <Flex
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    gap={4}
                >
                    <Box width={`${size}px`} height={`${size}px`}>
                        <Lottie
                            animationData={loaderAnimation}
                            loop={true}
                            autoplay={true}
                            style={{ width: '100%', height: '100%' }}
                        />
                    </Box>
                    {showMessage && (
                        <Text
                            color={messageColor}
                            fontSize="md"
                            fontWeight="500"
                            textAlign="center"
                        >
                            {message}
                        </Text>
                    )}
                </Flex>
            </Flex>
        );
    }

    // Inline loader (not full screen)
    return (
        <Flex
            alignItems="center"
            justifyContent="center"
            direction="column"
            gap={4}
            p={4}
        >
            <Box width={`${size}px`} height={`${size}px`}>
                <Lottie
                    animationData={loaderAnimation}
                    loop={true}
                    autoplay={true}
                    style={{ width: '100%', height: '100%' }}
                />
            </Box>
            {showMessage && (
                <Text
                    color={messageColor}
                    fontSize="md"
                    fontWeight="500"
                    textAlign="center"
                >
                    {message}
                </Text>
            )}
        </Flex>
    );
};

export default Loader;